





// import { useState, useEffect } from "react";
// import { FaSearch, FaPlusCircle, FaCamera } from "react-icons/fa";

// import { MdGridView } from "react-icons/md";
// import { useNavigate, useLocation } from "react-router-dom";
// import axios from "axios";
// import {
//   showSuccess,
//   showError,
// } from "../../General/Toast";
// import { FaEdit, FaTrash } from "react-icons/fa";





// const Services = ({clientData}) => {
//   const [showCategoryModal, setShowCategoryModal] = useState(false);
//   const [showUnitModal, setShowUnitModal] = useState(false);

//   const [newCategory, setNewCategory] = useState("");
//   const [newUnit, setNewUnit] = useState("");
//   const [searchTerm, setSearchTerm] = useState("");
//   // const client_id = localStorage.getItem("client_id");
//   const navigate = useNavigate();
//   const [showDeleteModal, setShowDeleteModal] = useState(false);
//   const [deleteItem, setDeleteItem] = useState(null);
//   const [editId, setEditId] = useState(null);
//   const location = useLocation();
//   const [showFilter, setShowFilter] = useState(false);
//   const [filterType, setFilterType] = useState("Products");
//   const [showItemForm, setShowItemForm] = useState(false);
//   const emptyService = {
//     name: "",
//     hsn_code: "",
//     category: "",
//     unit: "",
//     sale_price: "",
//     sale_price_withTax: "Without Tax",
//     discount: "",
//     dis_in_percent: "Amount",
//     taxRate: "",
//     image: null,
//     imagePreview: null,
//     typeOfItem: "service",
//   };
//   const client_id=clientData.id;

//   const [forms, setForms] = useState([{ ...emptyService }]);

//   const [categories, setCategories] = useState([]);
//   const [units, setUnits] = useState([]);
//   const [services, setServices] = useState([]);
//   const [purPriceWithTax, setPurPriceWithTax] = useState(false);
//   const [salePriceWithTax, setSalePriceWithTax] = useState(false);
//   const [discountInPercent, setDiscountInPercent] = useState(false);
//   const [productData, setProductData] = useState({
//     name: "",
//     hsn_code: "",
//     category: "",
//     unit: "",
//     sale_price: "",
//     sale_price_withTax: "Without Tax",
//     discount: "",
//     dis_in_percent: "Amount",
//     taxRate: "",
//     image: null,
//     typeOfItem: "service",
//   });

//   const handleEdit = (item) => {
//     setEditId(item.id);



//     setForms([
//       {
//         ...item,
//         typeOfItem: item.typeOfItem || "service",
//         image: null,
//         imagePreview: item.image
//           ? `https://api.dectwinbilling.com/dUploads/${item.image}`
//           : null,
//       },
//     ]);

//     setShowItemForm(true);

//     setShowItemForm(true);
//   };
//   const filteredServices = services.filter(
//     (item) =>
//       item.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       item.category?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       item.unit?.toLowerCase().includes(searchTerm.toLowerCase())
//   );
//   const handleAddCategory = async () => {
//     try {
//       await axios.post(
//         "https://api.dectwinbilling.com/add-category",
//         {
//           cat_name: newCategory,
//           cat_type: "category",
//           client_id,
//         }
//       );

//       showSuccess("Category Added successfully");

//       fetchCategories();

//       setProductData((prev) => ({
//         ...prev,
//         category: newCategory,
//       }));

//       setNewCategory("");
//       setShowCategoryModal(false);

//     } catch (error) {
//       showError(
//         error.response?.data?.message
//       );
//     }
//   };
//   const handleAddUnit = async () => {
//     try {
//       await axios.post(
//         "https://api.dectwinbilling.com/add-category",
//         {
//           cat_name: newUnit,
//           cat_type: "unit",
//           client_id,
//         }
//       );

//       showSuccess("Unit Added successfully");

//       fetchUnits();

//       setProductData((prev) => ({
//         ...prev,
//         unit: newUnit,
//       }));

//       setNewUnit("");
//       setShowUnitModal(false);

//     } catch (error) {
//       showError(
//         error.response?.data?.message
//       );
//     }
//   };
//   const fetchServices = async () => {
//     try {
//       const response = await axios.get(
//         `https://api.dectwinbilling.com/fetch-inventory/${client_id}`
//       );

//       const serviceData = response.data.filter(
//         (item) => item.typeOfItem === "service"
//       );

//       setServices(serviceData);

//     } catch (error) {
//       console.log(error);
//     }
//   };

//   const handleImageChange = (index, e) => {
//     const file = e.target.files[0];

//     if (!file) return;

//     const updatedForms = [...forms];

//     updatedForms[index].image = file;
//     updatedForms[index].imagePreview =
//       URL.createObjectURL(file);

//     setForms(updatedForms);
//   };
 
//   const handleDelete = (item) => {
//     setDeleteItem(item);
//     setShowDeleteModal(true);
//   };
//   const confirmDelete = async () => {
//     try {
//       await axios.delete(
//         `https://api.dectwinbilling.com/delete-inventory/${client_id}/${deleteItem.id}`
//       );

//       showSuccess("Service deleted successfully");

//       fetchServices();

//       setShowDeleteModal(false);
//       setDeleteItem(null);
//     } catch (error) {
//       showError(
//         error.response?.data?.message ||
//         "Something went wrong"
//       );
//     }
//   };
//   const fetchUnits = async () => {
//     try {
//       const response = await axios.get(
//         `https://api.dectwinbilling.com/fetch-unit/${client_id}`
//       );

//       setUnits(response.data);
//     } catch (error) {
//       console.log("Unit Fetch Error:", error);
//     }
//   };
//   useEffect(() => {
//     fetchCategories();
//     fetchUnits();
//     fetchServices();
//   }, []);
//   const fetchCategories = async () => {
//     try {
//       const response = await axios.get(
//         `https://api.dectwinbilling.com/fetch-category/${client_id}`
//       );

//       setCategories(response.data);
//     } catch (error) {
//       console.log("Category Fetch Error:", error);
//     }
//   };
//   const handleChange = (index, e) => {
//     const updatedForms = [...forms];

//     updatedForms[index] = {
//       ...updatedForms[index],
//       [e.target.name]: e.target.value,
//     };

//     setForms(updatedForms);
//   };

//   const handleAddMore = () => {
//     setForms([
//       ...forms,
//       { ...emptyService },
//     ]);

//   };
//   const handleAddLess = () => {
//     if (forms.length > 1) {
//       setForms(forms.slice(0, -1));
//     }
//   };


//   const handleSubmit = async () => {
//     try {

//       if (editId) {

        
//         const formData = new FormData();
//         Object.entries(forms[0]).forEach(([key, value]) => {

//           if (key === "imagePreview") return;

//           if (key === "image") {
//             if (value instanceof File) {
//               formData.append("image", value);
//             }
//             return;
//           }

         
//           formData.append(key, value == null ? "" : value);
//         });
//         formData.set("client_id", client_id);
//         formData.set("typeOfItem", "service");
//         formData.set("barcode", "");
//         formData.set("mfgDate", "");
//         formData.set("expDate", "");
//         formData.set("mrp", "");
//         formData.set("pur_price", "");
//         formData.set("pur_price_withTax", "");
//         formData.set("stock", "");
//         formData.set("stock_at_price", "");
//         formData.set("min_to_maintain", "");
//         formData.set("stock_place", "");
//         formData.set("date", new Date().toISOString().split("T")[0]);


//         await axios.put(
//           `https://api.dectwinbilling.com/edit-inventory/${editId}`,
//           formData,
//           {
//             headers: {
//               "Content-Type": "multipart/form-data",
//             },
//           }
//         );

//         showSuccess("Service Updated Successfully");

//       } else {

      
//         for (const form of forms) {

          
//           if (!form.name?.trim()) continue;

//           const formData = new FormData();

//           Object.keys(form).forEach((key) => {

//             if (key !== "imagePreview") {

//               formData.append(
//                 key,
//                 form[key]
//               );

//             }

//           });

//           formData.append(
//             "client_id",
//             client_id
//           );

//           formData.append("barcode", "");
//           formData.append("mfgDate", "");
//           formData.append("expDate", "");
//           formData.append("mrp", "");
//           formData.append("pur_price", "");
//           formData.append("pur_price_withTax", "");
//           formData.append("stock", "");
//           formData.append("stock_at_price", "");
//           formData.append("min_to_maintain", "");
//           formData.append("stock_place", "");
//           formData.append(
//             "date",
//             new Date().toISOString().split("T")[0]
//           );

//           await axios.post(
//             "https://api.dectwinbilling.com/inventory/upsert",
//             formData,
//             {
//               headers: {
//                 "Content-Type":
//                   "multipart/form-data",
//               },
//             }
//           );

//         }

//         showSuccess("Services Added Successfully");

//       }

//       fetchServices();

//       setEditId(null);

//       setForms([
//         { ...emptyService }
//       ]);

//       setShowItemForm(false);

//     } catch (error) {

//       console.log(error);

//       showError(
//         error.response?.data?.message ||
//         "Something went wrong"
//       );

//     }
//   };
//   return (


//     <div className="container-fluid p-2">

//       <div
//         className="card border-0 shadow overflow-hidden"
//         style={{
//           borderRadius: "20px",
//           minHeight: "540px"
//         }}
//       >


       

//         <div className="d-flex flex-column flex-md-row justify-content-between align-items-center p-3 gap-3">


//           <h5 className="fw-bold mb-0">
//             Services
//           </h5>



//           <div className="d-flex flex-wrap align-items-center gap-2 w-100 justify-content-center justify-content-md-end">


        

//             <div
//               className="d-flex align-items-center px-3"
//               style={{
//                 height: "38px",
//                 width: "250px",
//                 border: "2px solid var(--primary-color)",
//                 borderRadius: "8px"
//               }}
//             >

//               <input
//                 className="form-control border-0 shadow-none"
//                 placeholder="Search Service"
//                 value={searchTerm}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//               />

//               <FaSearch
//                 style={{
//                   color: "var(--primary-color)",
//                   fontSize: "18px"
//                 }}
//               />

//             </div>




         

//             <button
//               className="btn text-white fw-semibold d-flex align-items-center gap-2"
//               style={{
//                 backgroundColor: "var(--primary-color)",
//                 borderRadius: "8px",
//                 height: "38px"
//               }}
//               onClick={() => {

//                 setEditId(null);

//                 setProductData({
//                   name: "",
//                   hsn_code: "",
//                   category: "",
//                   unit: "",
//                   sale_price: "",
//                   sale_price_withTax: "Without Tax",
//                   discount: "",
//                   dis_in_percent: "Amount",
//                   taxRate: "",
//                   image: null,
//                   typeOfItem: "service",
//                 });

//                 setForms([{ ...emptyService }]);

//                 setShowItemForm(true);

//               }}
//             >

//               <FaPlusCircle />
//               Add Service

//             </button>




          

//             <button
//               className="grid-btn"
//               onClick={() => setShowFilter(!showFilter)}
//             >
//               <MdGridView />
//             </button>
           
//             {showCategoryModal && (
//               <div
//                 className="party-modal-overlay"
//                 style={{
//                   zIndex: 999999
//                 }}
//               >
//                 <div
//                   className="bg-white p-4"
//                   style={{
//                     width: "350px",
//                     borderRadius: "20px",
//                     position: "relative",
//                     zIndex: 1000000
//                   }}
//                 >
//                   <h4>Add Category</h4>

//                   <input
//                     className="form-control mt-3"
//                     placeholder="Enter Category"
//                     value={newCategory}
//                     onChange={(e) =>
//                       setNewCategory(e.target.value)
//                     }
//                   />

//                   <div className="mt-4 d-flex justify-content-end gap-3">
//                     <button
//                       className="btn btn-light"
//                       onClick={() =>
//                         setShowCategoryModal(false)
//                       }
//                     >
//                       Cancel
//                     </button>

//                     <button
//                       className="btn text-white"
//                       style={{
//                         background:
//                           "var(--primary-color)"
//                       }}
//                       onClick={handleAddCategory}
//                     >
//                       Add
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             )}
//             {showUnitModal && (
//               <div
//                 className="party-modal-overlay"
//                 style={{
//                   zIndex: 999999
//                 }}
//               >
//                 <div
//                   className="bg-white p-4"
//                   style={{
//                     width: "350px",
//                     borderRadius: "20px",
//                     position: "relative",
//                     zIndex: 1000000
//                   }}
//                 >
//                   <h4>Add Unit</h4>

//                   <input
//                     className="form-control mt-3"
//                     placeholder="Enter Unit"
//                     value={newUnit}
//                     onChange={(e) =>
//                       setNewUnit(e.target.value)
//                     }
//                   />

//                   <div className="mt-4 d-flex justify-content-end gap-3">
//                     <button
//                       className="btn btn-light"
//                       onClick={() =>
//                         setShowUnitModal(false)
//                       }
//                     >
//                       Cancel
//                     </button>

//                     <button
//                       className="btn text-white"
//                       style={{
//                         background:
//                           "var(--primary-color)"
//                       }}
//                       onClick={handleAddUnit}
//                     >
//                       Add
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             )}
//             {showDeleteModal && (
//               <div className="party-modal-overlay">
//                 <div
//                   className="bg-white p-4"
//                   style={{
//                     width: "350px",
//                     borderRadius: "15px",
//                     textAlign: "center",
//                   }}
//                 >
//                   <h5>Delete Service</h5>

//                   <p>
//                     Are you sure you want to delete
//                     <br />
//                     <strong>{deleteItem?.name}</strong> ?
//                   </p>

//                   <div className="d-flex justify-content-center gap-3 mt-4">
//                     <button
//                       className="btn btn-secondary"
//                       onClick={() => setShowDeleteModal(false)}
//                     >
//                       Cancel
//                     </button>

//                     <button
//                       className="btn btn-danger"
//                       onClick={confirmDelete}
//                     >
//                       Delete
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             )}
//             {showItemForm && (
//               <div className="party-modal-overlay">
//                 <div className="item-modal">

//                   <div className="item-modal-header">
//                     <h2>
//                       {editId ? "Edit Service" : "Add Service"}
//                     </h2>

//                     <button
//                       className="back-btn"
//                       onClick={() => {
//                         setShowItemForm(false);
//                         setEditId(null);

//                         setForms([{ ...emptyService }]);
//                       }}
//                     >
//                       ← Back
//                     </button>
//                   </div>

//                   <div className="product-layout">


//                     <div className="form-sections">

//                       {forms.map((form, index) => (
//                         <div
//                           key={index}
//                           className="product-card"
//                         >
//                           <div className="row">


//                             <div className="col-md-9">
//                               <h2 className="mb-3">
//                                 Product {index + 1}
//                               </h2>

//                               <div className="form-card">
//                                 <h3>Services</h3>

//                                 <div className="item-grid">
//                                   <input
//                                     name="name"
//                                     value={form.name}
//                                     onChange={(e) => handleChange(index, e)}
//                                     placeholder="Service Name *"
//                                   />

//                                   <input
//                                     name="hsn_code"
//                                     value={form.hsn_code}
//                                     onChange={(e) => handleChange(index, e)}
//                                     placeholder="SAC Code"
//                                   />



//                                   <select
//                                     name="category"
//                                     value={form.category}
//                                     onChange={(e) => {
//                                       if (e.target.value === "add-category") {
//                                         setShowCategoryModal(true);
//                                       } else {
//                                         handleChange(index, e);
//                                       }
//                                     }}
//                                   >
//                                     <option value="">Select Category</option>

//                                     {categories.map((cat) => (
//                                       <option key={cat.id} value={cat.cat_name}>
//                                         {cat.cat_name}
//                                       </option>
//                                     ))}

//                                     {!editId && (
//                                       <option value="add-category">
//                                         + Add Category
//                                       </option>
//                                     )}
//                                   </select>
                                 
//                                   <select
//                                     name="unit"
//                                     value={form.unit}
//                                     onChange={(e) => {
//                                       if (e.target.value === "add-unit") {
//                                         setShowUnitModal(true);
//                                       } else {
//                                         handleChange(index, e);
//                                       }
//                                     }}
//                                   >
//                                     <option value="">Select Unit</option>

//                                     {units.map((unit) => (
//                                       <option key={unit.id} value={unit.cat_name}>
//                                         {unit.cat_name}
//                                       </option>
//                                     ))}

//                                     {!editId && (
//                                       <option value="add-unit">
//                                         + Add Unit
//                                       </option>
//                                     )}
//                                   </select>

//                                 </div>
//                               </div>

//                               <div className="form-card">
//                                 <h3>Price </h3>

//                                 <div className="item-grid">


//                                   <div className="position-relative w-100">

//                                     <input
//                                       type="text"
//                                       name="sale_price"
//                                       value={form.sale_price}
//                                       onChange={(e) => handleChange(index, e)}
//                                       placeholder="Sale Price*"
//                                       className="form-control"
//                                       style={{ paddingRight: "120px" }}
//                                     />
//                                     <button
//                                       type="button"
//                                       className="btn btn-sm position-absolute top-50 end-0 translate-middle-y me-2"
//                                       onClick={() => {
//                                         const value = !salePriceWithTax;

//                                         setSalePriceWithTax(value);
//                                         const updatedForms = [...forms];

//                                         updatedForms[index].sale_price_withTax =
//                                           value ? "With Tax" : "Without Tax";

//                                         setForms(updatedForms);
//                                       }}
//                                       style={{
//                                         backgroundColor: "#F96E5B",
//                                         color: "#fff",
//                                         border: "none",
//                                         borderRadius: "20px",
//                                         minWidth: "95px",
//                                       }}
//                                     >
//                                       {form.sale_price_withTax || "Without Tax"}
//                                     </button>

//                                   </div>

//                                   <div className="position-relative w-100">

//                                     <input
//                                       type="text"
//                                       name="discount"
//                                       value={form.discount}
//                                       onChange={(e) => handleChange(index, e)}
//                                       placeholder="Discount"
//                                       className="form-control"
//                                       style={{ paddingRight: "120px" }}
//                                     />

//                                     <button
//                                       type="button"
//                                       className="btn btn-sm position-absolute top-50 end-0 translate-middle-y me-2"
//                                       style={{
//                                         backgroundColor: "#F96E5B",
//                                         color: "#fff",
//                                         border: "none",
//                                         borderRadius: "20px",
//                                         minWidth: "95px",
//                                       }}
//                                       onClick={() => {
//                                         const value = !discountInPercent;

//                                         setDiscountInPercent(value);
//                                         const updatedForms = [...forms];

//                                         updatedForms[index].dis_in_percent =
//                                           value ? "Percent" : "Amount";

//                                         setForms(updatedForms);
//                                       }}
//                                     >
//                                       {
//                                         form.dis_in_percent === "Percent"
//                                           ? "% Percentage"
//                                           : "₹ Amount"
//                                       }
//                                     </button>

//                                   </div>
                                

//                                   <select
//                                     name="taxRate"
//                                     value={form.taxRate}
//                                     onChange={(e) => handleChange(index, e)}
//                                   >
//                                     <option value="">Tax Rate</option>
//                                     <option value="None">None</option>
//                                     <option value="GST 0%">GST 0%</option>
//                                     <option value="IGST 0%">IGST 0%</option>
//                                     <option value="GST 0.25%">GST 0.25%</option>
//                                     <option value="IGST 0.25%">IGST 0.25%</option>
//                                     <option value="GST 3%">GST 3%</option>
//                                     <option value="IGST 3%">IGST 3%</option>
//                                     <option value="GST 5%">GST 5%</option>
//    <option value="IGST 5%">IGST 5%</option>
//      <option value="GST 12%">GST 12%</option>
//         <option value="IGST 12%">IGST 12%</option>
//              <option value="GST 18%">GST 18%</option>
//         <option value="IGST 18%">IGST 18%</option>
//              <option value="GST 28%">GST 28%</option>
//         <option value="IGST 28%">IGST 28%</option>
  

//                                   </select>
//                                 </div>
//                               </div>



//                             </div>


//                             <div className="col-md-3">
//                               <div className="image-upload-section">
//                                 <h3>Product Image</h3>

//                                 <div className="image-upload-box">
//                                   {form.imagePreview ? (
//                                     <img
//                                       src={form.imagePreview}
//                                       alt="preview"
//                                       className="preview-image"
//                                     />
//                                   ) : (
//                                     <div className="upload-placeholder">
//                                       <FaCamera size={50} />
//                                       <p>Upload Image</p>
//                                     </div>
//                                   )}

//                                   <input
//                                     type="file"
//                                     accept="image/*"
//                                     className="image-input"
//                                     onChange={(e) => handleImageChange(index, e)}
//                                   />
//                                 </div>
//                               </div>
//                             </div>

//                           </div>
//                         </div>
//                       ))}
//                     </div>

                 


//                   </div>

                 

//                   <div className="item-footer">

//                     {!editId && (
//                       <>
//                         <button
//                           className="more-btn"
//                           onClick={handleAddMore}
//                         >
//                           + Add More
//                         </button>

//                         <button
//                           className="less-btn"
//                           onClick={handleAddLess}
//                         >
//                           - Add Less
//                         </button>
//                       </>
//                     )}

//                     <button
//                       className="submit-btn"
//                       onClick={handleSubmit}
//                     >
//                       {editId ? "Update" : "Submit"}
//                     </button>

//                   </div>

//                 </div>
//               </div>
//             )}

//             {showFilter && (
//               <div className="filter-dropdown">

//                 <div
//                   className={location.pathname === "/items" ? "active-menu" : ""}
//                   onClick={() => {
//                     setFilterType("product");
//                     setShowFilter(false);
//                     navigate("/items");
//                   }}
//                 >
//                   Product
//                 </div>

//                 <div
//                   className={location.pathname === "/services" ? "active-menu" : ""}
//                   onClick={() => {
//                     setFilterType("Services");
//                     setShowFilter(false);
//                     navigate("/services");
//                   }}
//                 >
//                   Services
//                 </div>

//                 <div
//                   className={location.pathname === "/category" ? "active-menu" : ""}
//                   onClick={() => {
//                     setFilterType("Categories");
//                     setShowFilter(false);
//                     navigate("/category");
//                   }}
//                 >
//                   Categories
//                 </div>

//                 <div
//                   className={location.pathname === "/units" ? "active-menu" : ""}
//                   onClick={() => {
//                     setFilterType("Units");
//                     setShowFilter(false);
//                     navigate("/units");
//                   }}
//                 >
//                   Units
//                 </div>

//               </div>
//             )}



//           </div>


//         </div>






//         <div className="table-responsive">

      
//           <div
//             className="row text-white fw-semibold py-3 mx-0 flex-nowrap"
//             style={{
//               backgroundColor: "var(--primary-color)",
//               minWidth: "900px"
//             }}
//           >
//             <div className="col">Service Name</div>
//             <div className="col text-center">Category</div>
//             <div className="col text-center">Service Cost(₹)</div>
//             <div className="col text-center">Discount</div>
//             <div className="col text-center">Unit</div>
//             <div className="col text-center">Tax</div>
//             <div className="col text-center">Activity</div>
//           </div>

     
//           {filteredServices.map((item) => (
//             <div
//               key={item.id}
//               className="row py-3 border-bottom align-items-center mx-0 flex-nowrap"
//               style={{ minWidth: "900px" }}
//             >
//               <div className="col">{item.name}</div>

//               <div className="col text-center">
//                 {item.category}
//               </div>

//               <div className="col text-center">
//                 ₹{item.sale_price}
//               </div>

//               <div className="col text-center">
//                 {item.discount}
//               </div>

//               <div className="col text-center">
//                 {item.unit}
//               </div>

//               <div className="col text-center">
//                 {item.taxRate}
//               </div>

//               <div className="col text-center">
//                 <div className="d-flex justify-content-center gap-2">
//                   <button
//                     className="btn btn-sm btn-outline-primary"
//                     onClick={() => handleEdit(item)}
//                   >
//                     <FaEdit />
//                   </button>

//                   <button
//                     className="btn btn-sm btn-outline-danger"
//                     onClick={() => handleDelete(item)}
//                   >
//                     <FaTrash />
//                   </button>
//                 </div>
//               </div>
//             </div>
//           ))}

//         </div>





       


//       </div>

//     </div>

//   )

// }

// export default Services;

import { useState, useEffect } from "react";
import { FaSearch, FaPlusCircle, FaCamera } from "react-icons/fa";
import { MdGridView } from "react-icons/md";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import {
  showSuccess,
  showError,
} from "../../General/Toast";
import { FaEdit, FaTrash } from "react-icons/fa";

const Services = ({ clientData }) => {
  const [showCategoryModal, setShowCategoryModal] = useState(false);
  const [showUnitModal, setShowUnitModal] = useState(false);

  const [newCategory, setNewCategory] = useState("");
  const [newUnit, setNewUnit] = useState("");
  const [searchTerm, setSearchTerm] = useState("");

  const navigate = useNavigate();

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteItem, setDeleteItem] = useState(null);
  const [editId, setEditId] = useState(null);

  const location = useLocation();

  const [showFilter, setShowFilter] = useState(false);
  const [filterType, setFilterType] = useState("Products");
  const [showItemForm, setShowItemForm] = useState(false);

  const emptyService = {
    name: "",
    hsn_code: "",
    category: "",
    unit: "",
    sale_price: "",
    sale_price_withTax: "Without Tax",
    discount: "",
    dis_in_percent: "Amount",
    taxRate: "",
    image: null,
    imagePreview: null,
    typeOfItem: "service",
  };

  const client_id = clientData.id;

  const [forms, setForms] = useState([
    { ...emptyService },
  ]);

  const [categories, setCategories] = useState([]);
  const [units, setUnits] = useState([]);
  const [services, setServices] = useState([]);

  const [purPriceWithTax, setPurPriceWithTax] =
    useState(false);

  const [salePriceWithTax, setSalePriceWithTax] =
    useState(false);

  const [discountInPercent, setDiscountInPercent] =
    useState(false);

  const [productData, setProductData] = useState({
    name: "",
    hsn_code: "",
    category: "",
    unit: "",
    sale_price: "",
    sale_price_withTax: "Without Tax",
    discount: "",
    dis_in_percent: "Amount",
    taxRate: "",
    image: null,
    typeOfItem: "service",
  });

  const handleEdit = (item) => {
    setEditId(item.id);

    setForms([
      {
        ...item,

        typeOfItem:
          item.typeOfItem || "service",

        image: null,

        imagePreview: item.image
          ? `https://api.dectwinbilling.com/dUploads/${item.image}`
          : null,
      },
    ]);

    setShowItemForm(true);
  };

  const filteredServices = services.filter(
    (item) =>
      item.name
        ?.toLowerCase()
        .includes(searchTerm.toLowerCase()) ||

      item.category
        ?.toLowerCase()
        .includes(searchTerm.toLowerCase()) ||

      item.unit
        ?.toLowerCase()
        .includes(searchTerm.toLowerCase())
  );

  const handleAddCategory = async () => {
    try {
      await axios.post(
        "https://api.dectwinbilling.com/add-category",
        {
          cat_name: newCategory,
          cat_type: "category",
          client_id,
        }
      );

      showSuccess(
        "Category Added successfully"
      );

      fetchCategories();

      setProductData((prev) => ({
        ...prev,
        category: newCategory,
      }));

      setNewCategory("");
      setShowCategoryModal(false);

    } catch (error) {
      showError(
        error.response?.data?.message
      );
    }
  };

  const handleAddUnit = async () => {
    try {
      await axios.post(
        "https://api.dectwinbilling.com/add-category",
        {
          cat_name: newUnit,
          cat_type: "unit",
          client_id,
        }
      );

      showSuccess(
        "Unit Added successfully"
      );

      fetchUnits();

      setProductData((prev) => ({
        ...prev,
        unit: newUnit,
      }));

      setNewUnit("");
      setShowUnitModal(false);

    } catch (error) {
      showError(
        error.response?.data?.message
      );
    }
  };

  const fetchServices = async () => {
    try {
      const response = await axios.get(
        `https://api.dectwinbilling.com/fetch-inventory/${client_id}`
      );

      const serviceData =
        response.data.filter(
          (item) =>
            item.typeOfItem === "service"
        );

      setServices(serviceData);

    } catch (error) {
      console.log(error);
    }
  };

  const handleImageChange = (index, e) => {
    const file = e.target.files[0];

    if (!file) return;

    setForms((prev) => {
      const updated = [...prev];

      updated[index] = {
        ...updated[index],
        image: file,
        imagePreview:
          URL.createObjectURL(file),
      };

      return updated;
    });
  };

  const fetchCategories = async () => {
    try {
      const response = await axios.get(
        `https://api.dectwinbilling.com/fetch-categories/${client_id}`
      );

      setCategories(
        response.data.filter(
          (item) =>
            item.cat_type === "category"
        )
      );
    } catch (error) {
      console.log(error);
    }
  };

  const fetchUnits = async () => {
    try {
      const response = await axios.get(
        `https://api.dectwinbilling.com/fetch-categories/${client_id}`
      );

      setUnits(
        response.data.filter(
          (item) =>
            item.cat_type === "unit"
        )
      );
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchServices();
    fetchCategories();
    fetchUnits();
  }, [client_id]);

  const handleFormChange = (
    index,
    field,
    value
  ) => {
    setForms((prev) => {
      const updated = [...prev];

      updated[index] = {
        ...updated[index],
        [field]: value,
      };

      return updated;
    });
  };

  const handleAddMore = () => {
    setForms((prev) => [
      ...prev,
      { ...emptyService },
    ]);
  };

  const handleAddLess = () => {
    setForms((prev) => {
      if (prev.length <= 1) {
        return prev;
      }

      return prev.slice(0, -1);
    });
  };

  const handleSaveService = async () => {
    try {
      const formData = new FormData();

      forms.forEach((form, index) => {
        formData.append(
          `name_${index}`,
          form.name
        );

        formData.append(
          `hsn_code_${index}`,
          form.hsn_code || ""
        );

        formData.append(
          `category_${index}`,
          form.category || ""
        );

        formData.append(
          `unit_${index}`,
          form.unit || ""
        );

        formData.append(
          `sale_price_${index}`,
          form.sale_price || ""
        );

        formData.append(
          `sale_price_withTax_${index}`,
          form.sale_price_withTax ||
            "Without Tax"
        );

        formData.append(
          `discount_${index}`,
          form.discount || ""
        );

        formData.append(
          `dis_in_percent_${index}`,
          form.dis_in_percent || "Amount"
        );

        formData.append(
          `taxRate_${index}`,
          form.taxRate || ""
        );

        formData.append(
          `typeOfItem_${index}`,
          "service"
        );

        if (form.image) {
          formData.append(
            `image_${index}`,
            form.image
          );
        }
      });

      formData.append(
        "client_id",
        client_id
      );

      if (editId) {
        formData.append(
          "id",
          editId
        );

        await axios.put(
          `https://api.dectwinbilling.com/update-inventory/${editId}`,
          formData,
          {
            headers: {
              "Content-Type":
                "multipart/form-data",
            },
          }
        );

        showSuccess(
          "Service updated successfully"
        );

      } else {
        await axios.post(
          "https://api.dectwinbilling.com/add-inventory",
          formData,
          {
            headers: {
              "Content-Type":
                "multipart/form-data",
            },
          }
        );

        showSuccess(
          "Service added successfully"
        );
      }

      setShowItemForm(false);
      setEditId(null);
      setForms([{ ...emptyService }]);

      fetchServices();

    } catch (error) {
      console.log(error);

      showError(
        error.response?.data?.message ||
          "Something went wrong"
      );
    }
  };

  const confirmDelete = (item) => {
    setDeleteItem(item);
    setShowDeleteModal(true);
  };

  const handleDelete = async () => {
    if (!deleteItem) return;

    try {
      await axios.delete(
        `https://api.dectwinbilling.com/delete-inventory/${deleteItem.id}`
      );

      showSuccess(
        "Service deleted successfully"
      );

      setShowDeleteModal(false);
      setDeleteItem(null);

      fetchServices();

    } catch (error) {
      console.log(error);

      showError(
        error.response?.data?.message ||
          "Unable to delete service"
      );
    }
  };

  const resetForm = () => {
    setForms([{ ...emptyService }]);
    setEditId(null);
    setShowItemForm(false);
  };

  const openAddForm = () => {
    setForms([{ ...emptyService }]);
    setEditId(null);
    setShowItemForm(true);
  };

  /*
    IMPORTANT:
    Duplicate handleChange / handleSubmit ko yahan mat add karo.

    JSX mein:
      handleChange(index, e)

    ke instead existing:
      handleFormChange(index, e.target.name, e.target.value)

    use karenge.

    Submit ke liye:
      handleSaveService

    use karenge.
  */

  return (
    <>      <div className="services-page">
        <div className="container-fluid p-2">

          {/* ================= SERVICES LIST ================= */}

          <div className="card border-0 shadow-sm rounded-4">

            {/* HEADER */}
            <div
              className="
                d-flex
                flex-column
                flex-md-row
                justify-content-between
                align-items-md-center
                gap-3
                p-3
              "
            >

              <h5 className="mb-0 fw-bold">
                Services
              </h5>

              <div className="d-flex align-items-center gap-2">

                {/* SEARCH */}
                <div
                  className="position-relative"
                  style={{
                    width: "250px",
                  }}
                >
                  <FaSearch
                    className="position-absolute"
                    style={{
                      right: "12px",
                      top: "50%",
                      transform:
                        "translateY(-50%)",
                      color: "#98A2B3",
                      pointerEvents: "none",
                    }}
                  />

                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search Service"
                    value={searchTerm}
                    onChange={(e) =>
                      setSearchTerm(
                        e.target.value
                      )
                    }
                  />
                </div>

                {/* ADD SERVICE */}
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={openAddForm}
                >
                  <FaPlusCircle className="me-1" />
                  Add Service
                </button>

                {/* GRID
                <button
                  type="button"
                  className="btn btn-light grid-btn"
                  onClick={() =>
                    setShowFilter(
                      !showFilter
                    )
                  }
                >
                  <MdGridView size={18} />
                </button> */}
                {/* GRID / FILTER DROPDOWN */}
{/* GRID / PAGE DROPDOWN */}
<div
  className="position-relative d-inline-flex"
  style={{
    overflow: "visible",
    zIndex: 9999,
  }}
>
  {/* GRID BUTTON */}
  <button
    type="button"
    className="btn btn-light border rounded-3 d-flex align-items-center justify-content-center shadow-sm"
    style={{
      width: "40px",
      height: "40px",
    }}
    aria-label="Open pages"
    onClick={(e) => {
      e.preventDefault();
      e.stopPropagation();
      setShowFilter((prev) => !prev);
    }}
  >
    <MdGridView size={18} />
  </button>

  {/* DROPDOWN */}
 {/* DROPDOWN */}
{showFilter && (
  <div
    className="position-absolute end-0 mt-1 bg-white border rounded-3 shadow p-1"
    style={{
      top: "100%",
      width: "170px",
      zIndex: 99999,
    }}
    onClick={(e) => e.stopPropagation()}
  >
    {/* PRODUCTS */}
    <button
      type="button"
      className={`w-100 border-0 text-start rounded-2 px-3 py-2 fw-medium ${
        location.pathname === "/items"
          ? "bg-danger-subtle text-danger"
          : "bg-transparent text-secondary"
      }`}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();

        setFilterType("Products");
        setShowFilter(false);
        navigate("/items");
      }}
    >
      Products
    </button>

    {/* SERVICES */}
    <button
      type="button"
      className={`w-100 border-0 text-start rounded-2 px-3 py-2 fw-medium ${
        location.pathname === "/services"
          ? "bg-danger-subtle text-danger"
          : "bg-transparent text-secondary"
      }`}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();

        setFilterType("Services");
        setShowFilter(false);
        navigate("/services");
      }}
    >
      Services
    </button>

    {/* CATEGORIES */}
    <button
      type="button"
      className={`w-100 border-0 text-start rounded-2 px-3 py-2 fw-medium ${
        location.pathname === "/category"
          ? "bg-danger-subtle text-danger"
          : "bg-transparent text-secondary"
      }`}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();

        setFilterType("Categories");
        setShowFilter(false);
        navigate("/category");
      }}
    >
      Categories
    </button>

    {/* UNITS */}
    <button
      type="button"
      className={`w-100 border-0 text-start rounded-2 px-3 py-2 fw-medium ${
        location.pathname === "/units"
          ? "bg-danger-subtle text-danger"
          : "bg-transparent text-secondary"
      }`}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();

        setFilterType("Units");
        setShowFilter(false);
        navigate("/units");
      }}
    >
      Units
    </button>
  </div>
)}
</div>
              </div>
            </div>


            {/* TABLE */}
            <div className="table-responsive">

              <table className="table mb-0 align-middle">

                <thead>
                  <tr>
                    <th>Service Name</th>
                    <th>Category</th>
                    <th>Sale Price</th>
                    <th>GST</th>
                    <th>Activity</th>
                  </tr>
                </thead>

                <tbody>

                  {filteredServices.length > 0 ? (

                    filteredServices.map(
                      (item) => (
                        <tr key={item.id}>

                          <td>
                            {item.name}
                          </td>

                          <td>
                            {item.category}
                          </td>

                          <td>
                            ₹
                            {Number(
                              item.sale_price || 0
                            ).toFixed(2)}
                          </td>

                          <td>
                            {item.taxRate
                              ? `${item.taxRate}%`
                              : "-"}
                          </td>

                          <td>
                            <div className="d-flex gap-2">

                              {/* EDIT */}
                              <button
                                type="button"
                                className="
                                  btn
                                  btn-sm
                                  btn-outline-primary
                                "
                                onClick={() =>
                                  handleEdit(item)
                                }
                              >
                                <FaEdit />
                              </button>

                              {/* DELETE */}
                              <button
                                type="button"
                                className="
                                  btn
                                  btn-sm
                                  btn-outline-danger
                                "
                                onClick={() =>
                                  confirmDelete(item)
                                }
                              >
                                <FaTrash />
                              </button>

                            </div>
                          </td>

                        </tr>
                      )
                    )

                  ) : (

                    <tr>
                      <td
                        colSpan="5"
                        className="text-center py-5"
                      >
                        No services found
                      </td>
                    </tr>

                  )}

                </tbody>

              </table>

            </div>

          </div>

        </div>
      </div>


      {/* =========================================================
         ADD / EDIT SERVICE MODAL
         IMPORTANT: showItemForm condition
         ========================================================= */}

      {showItemForm && (

        <div
          className="party-modal-overlay"
          onClick={(e) => {

            if (
              e.target === e.currentTarget
            ) {
              resetForm();
            }

          }}
        >

          <div
            className="item-modal"
            onClick={(e) =>
              e.stopPropagation()
            }
          >

            {/* ================= MODAL HEADER ================= */}

            <div className="item-modal-header">

              <div>
                <h2 className="mb-0">
                  {editId
                    ? "Edit Service"
                    : "Add Service"}
                </h2>
              </div>

              <button
                type="button"
                className="back-btn"
                onClick={resetForm}
              >
                ← Back
              </button>

            </div>


            {/* ================= CONTENT ================= */}

            <div className="product-layout">

              <div className="form-sections">

                {forms.map(
                  (form, index) => (

                    <div
                      key={index}
                      className="product-card"
                    >

                      <div className="row">

                        {/* =================================================
                           LEFT FORM
                           ================================================= */}

                        <div className="col-md-9">

                          <h2 className="mb-3">
                            Service {index + 1}
                          </h2>


                          {/* ================= SERVICE DETAILS ================= */}

                          <div className="form-card">

                            <h3>
                              Service Details
                            </h3>

                            <div className="item-grid">

                              {/* SERVICE NAME */}
                              <input
                                name="name"
                                value={
                                  form.name || ""
                                }
                                onChange={(e) =>
                                  handleFormChange(
                                    index,
                                    e.target.name,
                                    e.target.value
                                  )
                                }
                                placeholder="Service Name *"
                              />


                              {/* SAC CODE */}
                              <input
                                name="hsn_code"
                                value={
                                  form.hsn_code || ""
                                }
                                onChange={(e) =>
                                  handleFormChange(
                                    index,
                                    e.target.name,
                                    e.target.value
                                  )
                                }
                                placeholder="SAC Code"
                              />


                              {/* CATEGORY */}
                              <select
                                name="category"
                                value={
                                  form.category || ""
                                }
                                onChange={(e) => {

                                  if (
                                    e.target.value ===
                                    "add-category"
                                  ) {

                                    setShowCategoryModal(
                                      true
                                    );

                                  } else {

                                    handleFormChange(
                                      index,
                                      e.target.name,
                                      e.target.value
                                    );

                                  }

                                }}
                              >

                                <option value="">
                                  Select Category
                                </option>

                                {categories.map(
                                  (cat) => (

                                    <option
                                      key={cat.id}
                                      value={
                                        cat.cat_name
                                      }
                                    >
                                      {cat.cat_name}
                                    </option>

                                  )
                                )}

                                {!editId && (
                                  <option value="add-category">
                                    + Add Category
                                  </option>
                                )}

                              </select>


                              {/* UNIT */}
                              <select
                                name="unit"
                                value={
                                  form.unit || ""
                                }
                                onChange={(e) => {

                                  if (
                                    e.target.value ===
                                    "add-unit"
                                  ) {

                                    setShowUnitModal(
                                      true
                                    );

                                  } else {

                                    handleFormChange(
                                      index,
                                      e.target.name,
                                      e.target.value
                                    );

                                  }

                                }}
                              >

                                <option value="">
                                  Select Unit
                                </option>

                                {units.map(
                                  (unit) => (

                                    <option
                                      key={unit.id}
                                      value={
                                        unit.cat_name
                                      }
                                    >
                                      {unit.cat_name}
                                    </option>

                                  )
                                )}

                                {!editId && (
                                  <option value="add-unit">
                                    + Add Unit
                                  </option>
                                )}

                              </select>

                            </div>

                          </div>


                          {/* ================= PRICE DETAILS ================= */}

                          <div className="form-card">

                            <h3>
                              Price Details
                            </h3>

                            <div className="item-grid">

                              {/* SALE PRICE */}
                              <div className="position-relative w-100">

                                <input
                                  type="text"
                                  name="sale_price"
                                  value={
                                    form.sale_price || ""
                                  }
                                  onChange={(e) =>
                                    handleFormChange(
                                      index,
                                      e.target.name,
                                      e.target.value
                                    )
                                  }
                                  placeholder="Sale Price *"
                                  className="form-control"
                                />

                                <button
                                  type="button"
                                  className="
                                    btn
                                    btn-sm
                                    position-absolute
                                    top-50
                                    end-0
                                    translate-middle-y
                                    me-2
                                  "
                                  onClick={() => {

                                    const value =
                                      !salePriceWithTax;

                                    setSalePriceWithTax(
                                      value
                                    );

                                    setForms((prev) => {

                                      const updated =
                                        [...prev];

                                      updated[index] = {
                                        ...updated[index],
                                        sale_price_withTax:
                                          value
                                            ? "With Tax"
                                            : "Without Tax",
                                      };

                                      return updated;

                                    });

                                  }}
                                >
                                  {
                                    form.sale_price_withTax ||
                                    "Without Tax"
                                  }
                                </button>

                              </div>


                              {/* DISCOUNT */}
                              <div className="position-relative w-100">

                                <input
                                  type="text"
                                  name="discount"
                                  value={
                                    form.discount || ""
                                  }
                                  onChange={(e) =>
                                    handleFormChange(
                                      index,
                                      e.target.name,
                                      e.target.value
                                    )
                                  }
                                  placeholder="Discount"
                                  className="form-control"
                                />

                                <button
                                  type="button"
                                  className="
                                    btn
                                    btn-sm
                                    position-absolute
                                    top-50
                                    end-0
                                    translate-middle-y
                                    me-2
                                  "
                                  onClick={() => {

                                    const value =
                                      !discountInPercent;

                                    setDiscountInPercent(
                                      value
                                    );

                                    setForms((prev) => {

                                      const updated =
                                        [...prev];

                                      updated[index] = {
                                        ...updated[index],
                                        dis_in_percent:
                                          value
                                            ? "Percent"
                                            : "Amount",
                                      };

                                      return updated;

                                    });

                                  }}
                                >
                                  {
                                    form.dis_in_percent ===
                                    "Percent"
                                      ? "% Percentage"
                                      : "₹ Amount"
                                  }
                                </button>

                              </div>


                              {/* TAX */}
                              <select
                                name="taxRate"
                                value={
                                  form.taxRate || ""
                                }
                                onChange={(e) =>
                                  handleFormChange(
                                    index,
                                    e.target.name,
                                    e.target.value
                                  )
                                }
                              >

                                <option value="">
                                  Tax Rate
                                </option>

                                <option value="None">
                                  None
                                </option>

                                <option value="GST 0%">
                                  GST 0%
                                </option>

                                <option value="IGST 0%">
                                  IGST 0%
                                </option>

                                <option value="GST 0.25%">
                                  GST 0.25%
                                </option>

                                <option value="IGST 0.25%">
                                  IGST 0.25%
                                </option>

                                <option value="GST 3%">
                                  GST 3%
                                </option>

                                <option value="IGST 3%">
                                  IGST 3%
                                </option>

                                <option value="GST 5%">
                                  GST 5%
                                </option>

                                <option value="IGST 5%">
                                  IGST 5%
                                </option>

                                <option value="GST 12%">
                                  GST 12%
                                </option>

                                <option value="IGST 12%">
                                  IGST 12%
                                </option>

                                <option value="GST 18%">
                                  GST 18%
                                </option>

                                <option value="IGST 18%">
                                  IGST 18%
                                </option>

                                <option value="GST 28%">
                                  GST 28%
                                </option>

                                <option value="IGST 28%">
                                  IGST 28%
                                </option>

                              </select>

                            </div>

                          </div>

                        </div>


                        {/* =================================================
                           RIGHT IMAGE
                           ================================================= */}

                        <div className="col-md-3">

                          <div className="image-upload-section">

                            <h3>
                              Service Image
                            </h3>

                            <div className="image-upload-box">

                              {form.imagePreview ? (

                                <img
                                  src={
                                    form.imagePreview
                                  }
                                  alt="Service preview"
                                  className="preview-image"
                                />

                              ) : (

                                <div className="upload-placeholder">

                                  <FaCamera
                                    size={45}
                                  />

                                  <p>
                                    Upload Image
                                  </p>

                                </div>

                              )}

                              <input
                                type="file"
                                accept="image/*"
                                className="image-input"
                                onChange={(e) =>
                                  handleImageChange(
                                    index,
                                    e
                                  )
                                }
                              />

                            </div>

                          </div>

                        </div>

                      </div>

                    </div>

                  )
                )}

              </div>

            </div>


            {/* =====================================================
               FOOTER
               ===================================================== */}

            <div className="item-footer">

              {!editId && (
                <>

                  <button
                    type="button"
                    className="more-btn"
                    onClick={handleAddMore}
                  >
                    + Add More
                  </button>

                  <button
                    type="button"
                    className="less-btn"
                    onClick={handleAddLess}
                  >
                    − Add Less
                  </button>

                </>
              )}

              <button
                type="button"
                className="submit-btn"
                onClick={handleSaveService}
              >
                {editId
                  ? "Update"
                  : "Submit"}
              </button>

            </div>

          </div>

        </div>

      )}      {/* ================= ADD CATEGORY MODAL ================= */}

      {showCategoryModal && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          role="dialog"
          style={{
            backgroundColor: "rgba(0,0,0,0.5)",
            zIndex: 100000,
          }}
          onClick={() =>
            setShowCategoryModal(false)
          }
        >
          <div
            className="modal-dialog modal-dialog-centered"
            onClick={(e) =>
              e.stopPropagation()
            }
          >
            <div className="modal-content border-0 rounded-4 shadow">

              <div className="modal-header">
                <h5 className="modal-title fw-bold">
                  Add Category
                </h5>

                <button
                  type="button"
                  className="btn-close"
                  onClick={() =>
                    setShowCategoryModal(false)
                  }
                />
              </div>

              <div className="modal-body">

                <label className="form-label fw-semibold">
                  Category Name
                </label>

                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter category name"
                  value={newCategory}
                  onChange={(e) =>
                    setNewCategory(
                      e.target.value
                    )
                  }
                />

              </div>

              <div className="modal-footer">

                <button
                  type="button"
                  className="btn btn-light"
                  onClick={() =>
                    setShowCategoryModal(false)
                  }
                >
                  Cancel
                </button>

                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleAddCategory}
                >
                  Add Category
                </button>

              </div>

            </div>
          </div>
        </div>
      )}


      {/* ================= ADD UNIT MODAL ================= */}

      {showUnitModal && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          role="dialog"
          style={{
            backgroundColor: "rgba(0,0,0,0.5)",
            zIndex: 100000,
          }}
          onClick={() =>
            setShowUnitModal(false)
          }
        >
          <div
            className="modal-dialog modal-dialog-centered"
            onClick={(e) =>
              e.stopPropagation()
            }
          >
            <div className="modal-content border-0 rounded-4 shadow">

              <div className="modal-header">
                <h5 className="modal-title fw-bold">
                  Add Unit
                </h5>

                <button
                  type="button"
                  className="btn-close"
                  onClick={() =>
                    setShowUnitModal(false)
                  }
                />
              </div>

              <div className="modal-body">

                <label className="form-label fw-semibold">
                  Unit Name
                </label>

                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter unit name"
                  value={newUnit}
                  onChange={(e) =>
                    setNewUnit(
                      e.target.value
                    )
                  }
                />

              </div>

              <div className="modal-footer">

                <button
                  type="button"
                  className="btn btn-light"
                  onClick={() =>
                    setShowUnitModal(false)
                  }
                >
                  Cancel
                </button>

                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleAddUnit}
                >
                  Add Unit
                </button>

              </div>

            </div>
          </div>
        </div>
      )}


      {/* ================= DELETE MODAL ================= */}

      {showDeleteModal && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          role="dialog"
          style={{
            backgroundColor: "rgba(0,0,0,0.5)",
            zIndex: 100000,
          }}
          onClick={() =>
            setShowDeleteModal(false)
          }
        >
          <div
            className="modal-dialog modal-dialog-centered"
            onClick={(e) =>
              e.stopPropagation()
            }
          >
            <div className="modal-content border-0 rounded-4 shadow">

              <div className="modal-header">
                <h5 className="modal-title fw-bold">
                  Delete Service
                </h5>

                <button
                  type="button"
                  className="btn-close"
                  onClick={() => {
                    setShowDeleteModal(false);
                    setDeleteItem(null);
                  }}
                />
              </div>

              <div className="modal-body">

                <p className="mb-0 text-muted">
                  Are you sure you want to delete{" "}
                  <strong className="text-dark">
                    {deleteItem?.name}
                  </strong>
                  ?
                </p>

              </div>

              <div className="modal-footer">

                <button
                  type="button"
                  className="btn btn-light"
                  onClick={() => {
                    setShowDeleteModal(false);
                    setDeleteItem(null);
                  }}
                >
                  Cancel
                </button>

                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={handleDelete}
                >
                  Delete
                </button>

              </div>

            </div>
          </div>
        </div>
      )}      <style>{`

        .services-page {
          width: 100%;
          max-width: 100%;
          overflow-x: hidden;
        }

        .services-page * {
          box-sizing: border-box;
        }

        .services-page .card {
          min-width: 0;
        }

        .services-page .table-responsive {
          width: 100%;
          overflow-x: auto;
          -webkit-overflow-scrolling: touch;
        }

        .services-page table {
          width: 100%;
          margin-bottom: 0;
        }

        .services-page th {
          background: #ff6b5f;
          color: #fff;
          font-weight: 600;
          white-space: nowrap;
        }

        .services-page td {
          white-space: nowrap;
        }

        .grid-btn {
          width: 40px;
          height: 38px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          padding: 0;
        }


        /* =========================
           SERVICE MODAL
           ========================= */

        .party-modal-overlay {
          position: fixed;
          inset: 0;
          z-index: 99999;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 15px;
          background: rgba(15, 23, 42, 0.58);
          backdrop-filter: blur(3px);
        }

        .item-modal {
          width: min(1180px, 100%);
          max-width: 1180px;
          max-height: calc(100vh - 30px);
          background: #f7f9fc;
          border-radius: 18px;
          overflow: hidden auto;
          box-shadow:
            0 25px 70px rgba(0,0,0,.25);
        }

        .item-modal-header {
          position: sticky;
          top: 0;
          z-index: 10;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 12px;
          padding: 15px 18px;
          background: #fff;
          border-bottom: 1px solid #e9ecef;
        }

        .item-modal-header h2 {
          margin: 0;
          font-size: 20px;
          font-weight: 700;
        }

        .back-btn {
          border: 1px solid #dee2e6;
          background: #fff;
          border-radius: 8px;
          padding: 7px 13px;
          font-size: 13px;
          cursor: pointer;
        }

        .product-layout {
          width: 100%;
          padding: 18px;
        }

        .product-card {
          width: 100%;
          margin-bottom: 15px;
        }

        .product-card > .row {
          display: grid;
          grid-template-columns:
            minmax(0, 3fr)
            minmax(250px, 1fr);
          gap: 18px;
          margin: 0;
        }

        .product-card > .row > .col-md-9,
        .product-card > .row > .col-md-3 {
          width: auto;
          max-width: none;
          padding: 0;
          min-width: 0;
        }


        /* =========================
           FORM CARDS
           ========================= */

        .form-card,
        .image-upload-section {
          width: 100%;
          background: #fff;
          border: 1px solid #e7ebf1;
          border-radius: 14px;
          padding: 16px;
          margin-bottom: 15px;
          box-shadow: 0 3px 12px rgba(0,0,0,.04);
        }

        .form-card h3,
        .image-upload-section h3 {
          margin: 0 0 13px;
          font-size: 16px;
          font-weight: 700;
        }

        .item-grid {
          width: 100%;
          display: grid;
          grid-template-columns:
            repeat(3, minmax(0, 1fr));
          gap: 10px;
        }

        .item-grid > * {
          min-width: 0;
        }

        .item-grid input,
        .item-grid select {
          width: 100%;
          height: 42px;
          min-width: 0;
          border: 1px solid #d9dee7;
          border-radius: 8px;
          padding: 0 11px;
          font-size: 13px;
          outline: none;
          background: #fff;
        }

        .item-grid input:focus,
        .item-grid select:focus {
          border-color: #0d6efd;
          box-shadow:
            0 0 0 2px rgba(13,110,253,.08);
        }


        /* =========================
           IMAGE
           ========================= */

        .image-upload-box {
          position: relative;
          width: 100%;
          min-height: 250px;
          border: 1px dashed #ccd4df;
          border-radius: 12px;
          overflow: hidden;
          background: #f9fafc;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .upload-placeholder {
          width: 100%;
          height: 100%;
          min-height: 250px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          color: #adb5bd;
        }

        .upload-placeholder p {
          margin: 10px 0 0;
          font-size: 13px;
        }

        .image-input {
          position: absolute;
          inset: 0;
          width: 100%;
          height: 100%;
          opacity: 0;
          cursor: pointer;
        }

        .preview-image {
          width: 100%;
          height: 250px;
          object-fit: contain;
          display: block;
        }


        /* =========================
           PRICE TOGGLE BUTTON
           ========================= */

        .item-grid .position-relative {
          min-width: 0;
        }

        .item-grid
        .position-relative
        input {
          padding-right: 105px;
        }

        .item-grid
        .position-relative
        button {
          white-space: nowrap;
          font-size: 11px;
          padding: 3px 6px;
          border: 0;
          background: transparent;
        }


        /* =========================
           FOOTER
           ========================= */

        .item-footer {
          position: sticky;
          bottom: 0;
          z-index: 10;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          gap: 8px;
          padding: 10px 15px;
          background: #fff;
          border-top: 1px solid #e9ecef;
        }

        .item-footer button {
          min-width: 105px;
          height: 38px;
          border-radius: 8px;
          font-size: 12px;
          font-weight: 600;
          cursor: pointer;
        }

        .more-btn {
          border: 1px solid #ff6b5f;
          background: #fff;
          color: #ff6b5f;
        }

        .less-btn {
          border: 1px solid #dee2e6;
          background: #fff;
          color: #6c757d;
        }

        .submit-btn {
          border: 0;
          background: #ff6b5f;
          color: #fff;
        }


        /* =========================
           MOBILE
           ========================= */

        @media (max-width: 767.98px) {

          .services-page .container-fluid {
            padding: 6px !important;
          }

          .services-page
          .d-flex.flex-column.flex-md-row {
            padding: 9px !important;
            gap: 8px !important;
          }

          .services-page
          .d-flex.flex-column.flex-md-row
          > .d-flex {
            width: 100% !important;
            display: grid !important;
            grid-template-columns:
              minmax(0, 1fr)
              auto
              36px;
            gap: 5px !important;
          }

          .services-page
          .d-flex.flex-column.flex-md-row
          > .d-flex
          > div {
            width: 100% !important;
            min-width: 0 !important;
          }

          .services-page
          .d-flex.flex-column.flex-md-row
          input {
            width: 100% !important;
            height: 36px !important;
            font-size: 11px !important;
          }

          .services-page
          .d-flex.flex-column.flex-md-row
          > .d-flex
          > button {
            height: 36px !important;
            min-height: 36px !important;
            padding: 0 9px !important;
            font-size: 10px !important;
            white-space: nowrap;
          }

          .services-page .grid-btn {
            width: 36px !important;
            min-width: 36px !important;
            padding: 0 !important;
          }


          /* SERVICE MODAL */

          .party-modal-overlay {
            padding: 5px;
            align-items: center;
          }

          .item-modal {
            width: 100%;
            max-width: 100%;
            height: calc(100dvh - 10px);
            max-height: calc(100dvh - 10px);
            border-radius: 13px;
          }

          .item-modal-header {
            min-height: 45px;
            padding: 8px 10px;
          }

          .item-modal-header h2 {
            font-size: 15px;
          }

          .back-btn {
            padding: 5px 9px;
            font-size: 10px;
          }

          .product-layout {
            padding: 8px;
          }

          .product-card > .row {
            grid-template-columns:
              minmax(0, 1fr) !important;
            grid-template-rows:
              auto auto;
            gap: 8px;
          }

          .product-card > .row
          > .col-md-9,
          .product-card > .row
          > .col-md-3 {
            width: 100% !important;
            grid-column: 1 !important;
          }

          .product-card > .row
          > .col-md-9 {
            grid-row: 1 !important;
          }

          .product-card > .row
          > .col-md-3 {
            grid-row: 2 !important;
          }

          .form-card,
          .image-upload-section {
            padding: 9px;
            margin-bottom: 8px;
            border-radius: 9px;
          }

          .form-card h3,
          .image-upload-section h3 {
            font-size: 12px;
            margin-bottom: 7px;
          }

          .product-card h2 {
            font-size: 14px;
            margin-bottom: 8px !important;
          }

          .item-grid {
            grid-template-columns:
              repeat(2, minmax(0, 1fr));
            gap: 5px;
          }

          .item-grid input,
          .item-grid select {
            height: 36px;
            min-height: 36px;
            font-size: 10px;
            padding: 0 7px;
            border-radius: 7px;
          }

          .item-grid
          .position-relative
          input {
            padding-right: 65px;
          }

          .item-grid
          .position-relative
          button {
            right: 2px !important;
            margin-right: 2px !important;
            min-width: 50px;
            font-size: 7px;
            padding: 2px;
          }

          .image-upload-box {
            min-height: 135px;
            height: 135px;
          }

          .upload-placeholder {
            min-height: 135px;
          }

          .preview-image {
            height: 135px;
          }

          .item-footer {
            display: grid;
            grid-template-columns:
              repeat(2, minmax(0, 1fr));
            gap: 5px;
            padding: 6px;
          }

          .item-footer button {
            width: 100%;
            min-width: 0;
            height: 34px;
            font-size: 9px;
          }

          .item-footer
          .submit-btn {
            grid-column: 1 / -1;
          }


          /* BOOTSTRAP SMALL MODALS */

          .modal-dialog {
            width: auto;
            margin: 10px;
          }

          .modal-content {
            border-radius: 14px !important;
          }

          .modal-header {
            padding: 11px 13px;
          }

          .modal-body {
            padding: 13px;
          }

          .modal-footer {
            padding: 9px 13px;
          }

        }


        /* =========================
           VERY SMALL MOBILE
           ========================= */

        @media (max-width: 360px) {

          .services-page
          .d-flex.flex-column.flex-md-row
          > .d-flex {
            grid-template-columns:
              minmax(0, 1fr)
              auto
              32px;
            gap: 4px !important;
          }

          .services-page
          .d-flex.flex-column.flex-md-row
          input {
            height: 34px !important;
            font-size: 9px !important;
          }

          .services-page
          .d-flex.flex-column.flex-md-row
          > .d-flex
          > button {
            height: 34px !important;
            min-height: 34px !important;
            font-size: 9px !important;
            padding: 0 7px !important;
          }

          .services-page .grid-btn {
            width: 32px !important;
            min-width: 32px !important;
          }

          .item-modal-header h2 {
            font-size: 14px;
          }

          .item-grid {
            gap: 4px;
          }

          .item-grid input,
          .item-grid select {
            font-size: 9px;
            height: 34px;
          }

          .image-upload-box,
          .upload-placeholder {
            height: 120px;
            min-height: 120px;
          }

          .preview-image {
            height: 120px;
          }

        }

      `}</style>
          </>
  );
};

export default Services;